<span class=" rounded text-sm text-white text-center flex-shrink px-2 py-1" [ngClass]="{
 'bg-blue-400': environmentType === 'dev',
 'bg-orange-400': environmentType === 'staging',
 'bg-purple-500': environmentType === 'preview'
}">
  <span *ngIf="environmentType === 'dev'">
    Développement
  </span>
  <span *ngIf="environmentType === 'staging'">
    Recette
  </span>
  <span *ngIf="environmentType === 'preview'">
    Preview
  </span>
</span>
